import { colors, fontSize, theme } from '@noths/polaris-client-ribbons-base';
import { applyKeyframe } from '@noths/polaris-client-styles';
import { css, keyframes } from 'styled-components';

const { fonts, text } = theme;

const appear = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const uploadButton = css`
  &:disabled {
    background-color: ${colors.neutralPrimary};
  }
`;

export const errorField = css`
  display: flex;
  animation: ${applyKeyframe(appear)} 0.25s ease-in-out;
  animation-fill-mode: forwards;
  ${fontSize(text.BODY.XS)};
  font-family: ${fonts.PRIMARY_REGULAR.family};
  font-weight: ${fonts.PRIMARY_REGULAR.weight};
  margin-top: 0.25rem;
  color: ${colors.functionalRedPrimary};
  > div {
    margin-right: 0.25rem;
    flex-shrink: 0;
  }
`;

export const fileUploadedContainer = css`
  position: relative;
  background-color: #eef1f3;
  border-radius: 0.625rem;
  padding: 1rem;
  width: 100%;
  max-width: 30rem;
  margin-bottom: 1rem;
`;

export const uploadedFileName = css`
  margin-right: 2rem;
  font-size: 0.875rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const deleteUploadedFileButton = css`
  position: absolute;
  top: 0.45rem;
  right: 0.7rem;
`;

export const uploadingSpinner = css`
  position: absolute;
  top: 0.6rem;
  right: 0.7rem;
  color: ${colors.brandBluePrimary};
`;
